import { connect } from 'react-redux';
import { makeSortedChannelsByIndex } from './channelsSelectors';
import { setChannelActive } from '../../redux/ui/actions';
import Channels from '../../Components/Channels/Channels';

const mapState2Props = (state: any) => {
    return {
        channels: makeSortedChannelsByIndex(state),
    };
};
const mapDispatchToProps = {
    setChannelActive,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(Channels);
